/*
 * BuenaVida homepage popup controller.
 * Centered accessible modal: delayed open with frequency cap, auto-open on the
 * success state (code reveal), focus trap + scroll lock, ESC + backdrop close,
 * inline email validation. No inline handlers, no alert().
 */
(function () {
  'use strict';

  var popup = document.querySelector('[data-bv-popup]');
  if (!popup) return;
  var card = popup.querySelector('.bv-popup-card');

  var KEY = 'bv_popup_expiry';
  var delay = (parseInt(popup.getAttribute('data-delay'), 10) || 5) * 1000;
  var cookieDays = parseInt(popup.getAttribute('data-cookie-days'), 10) || 14;
  var lastFocus = null;

  function focusables() {
    return card.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])');
  }
  function setCookie() {
    try { localStorage.setItem(KEY, String(Date.now() + cookieDays * 86400000)); } catch (e) {}
  }
  function suppressed() {
    try { var x = localStorage.getItem(KEY); return x && Date.now() < parseInt(x, 10); } catch (e) { return false; }
  }
  function open() {
    lastFocus = document.activeElement;
    popup.classList.add('bv-active');
    popup.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    var f = focusables();
    (f[0] || card).focus();
  }
  function close() {
    popup.classList.remove('bv-active');
    popup.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    setCookie();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  // Auto-open: on the success state show immediately; otherwise respect delay + cap.
  if (popup.querySelector('[data-bv-success]')) {
    open();
  } else if (!suppressed()) {
    setTimeout(open, delay);
  }

  // Close: X button or click on the dimmed backdrop (outside the card).
  popup.addEventListener('click', function (e) {
    if (e.target.closest('[data-bv-popup-close]')) { close(); return; }
    if (!e.target.closest('.bv-popup-card')) { close(); }
  });

  // Keyboard: ESC closes; Tab is trapped within the card.
  document.addEventListener('keydown', function (e) {
    if (!popup.classList.contains('bv-active')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  // Inline email validation; persist the frequency cap on a valid submit.
  var form = popup.querySelector('#bv-popup-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      var email = form.querySelector('#bv-popup-email');
      var err = form.querySelector('[data-bv-error]');
      if (email && !/.+@.+\..+/.test(email.value.trim())) {
        e.preventDefault();
        if (err) err.hidden = false;
        email.focus();
        return;
      }
      setCookie();
    });
  }
})();
